import { makeStyles, Theme } from '@material-ui/core';

type styleProps = {
  color: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.neutral.light,
    height: theme.spacing(1),
    borderRadius: theme.spacing(2.5),
  },
  container: {
    width: 'max-content',
    paddingBottom: theme.spacing(4.75),
  },
  bar: (props: styleProps) => ({
    backgroundColor: props.color,
  }),
}));

export default useStyles;
